import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import HoverHint from './hoverHint';
import { useMembershipAccess } from '../../hooks/membership';

const hasText = (value) => (typeof value === 'string' ? value.trim().length > 0 : Boolean(value));

export default function DealRecipientCompany({
  companyName,
  companyUrl,
  hasInfo,
  accessMode = 'professionalOnly',
  className = '',
  lockedLabel,
  hintMessage,
}) {
  const { t } = useTranslation();
  const { canViewDealRecipientCompany } = useMembershipAccess();

  const infoExists = typeof hasInfo === 'boolean' ? hasInfo : hasText(companyName) || hasText(companyUrl);
  if (!infoExists) return null;

  const canShow =
    accessMode === 'full' ||
    (accessMode === 'professionalOnly' && canViewDealRecipientCompany);

  const trimmedName = hasText(companyName) ? companyName.trim() : '';
  const safeUrl = hasText(companyUrl) ? companyUrl.trim() : '';
  const visibleLabel = trimmedName || t('app:deals.companySite', { defaultValue: 'Company site' });
  const lockedText =
    lockedLabel || t('app:deals.companySite', { defaultValue: 'Company site' });
  const lockedHint =
    hintMessage ||
    t('pageFindInvestors.requires2', { defaultValue: 'Requires Professional plan' });

  if (canShow && safeUrl) {
    return (
      <a
        href={safeUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center gap-1.5 text-sm text-stone-600 hover:text-stone-900 hover:underline ${className}`}
        title={visibleLabel}
      >
        <ExternalLink aria-hidden className="h-3.5 w-3.5 shrink-0" />
        <span className="break-words">{visibleLabel}</span>
      </a>
    );
  }

  if (canShow && trimmedName) {
    return (
      <span className={`inline-flex items-center text-sm text-stone-600 ${className}`}>
        {trimmedName}
      </span>
    );
  }

  return (
    <HoverHint message={lockedHint}>
      <span className={`inline-flex items-center gap-1.5 text-sm text-stone-500 ${className}`}>
        <ExternalLink aria-hidden className="h-3.5 w-3.5 shrink-0" />
        <span>{lockedText}</span>
      </span>
    </HoverHint>
  );
}
